import {FileBrowserEntry} from "./file-browser-entry";

export class FileBrowserUploadData {
  parent: FileBrowserEntry;
  files: any[] = [];
}
